import React from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";

const Candidates = () => {
  return <AuthLayout>Candidates</AuthLayout>;
};

export default Candidates;
